import * as React from 'react';

import * as styles from './NewbuildingFeaturesSection.css';

export const NewbuildingFeaturesSection: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
